<form-group class="w-36">
  <label class="absolute inset-0 z-20" (click)="onOpenCalendar(dateInput)">
    <svg class="w-5 h-5 absolute top-1/2 right-2.5 -translate-y-1/2 text-sky-500">
      <use xlink:href="assets/icons/symbols.svg#calendar"></use>
    </svg>
  </label>
  <input
    type="date"
    placeholder="Pick a date"
    class="opacity-0 h-12"
    [min]="min()"
    [max]="max()"
    [(ngModel)]="value"
    #dateInput
  />
  <label emsysLabel class="focus-within" for="date-from">{{label()}}</label>
  <div class="absolute h-12 pt-4 pb-1 px-2.5 inset-0">
    <ng-content></ng-content>
  </div>
</form-group>
